import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../../share-components/AppContext';
import "./OrderAvailableProduct.scss";
import { Button, Card } from 'react-bootstrap';
import { customStorage, formatDateTime, getPayloadData, isNullOrEmptyString, isValidHttpUrl } from '../../services/UtilityService';
import { DELI_TYPE_DEFINE, DELI_TYPES, ORDER_STATUS, ORDER_STATUS_DEFINE, SERVER_ERROR_MESSAGE, TOKEN_SESSION_KEY } from '../../constants/commonConstants';
import { cancelOrder, finishOrder, getOrderDetails } from '../../services/ManagementService';
import { ROUTE_ORDER_CREATE, ROUTE_ORDER_DELI_EDIT, ROUTE_ORDER_EDIT, ROUTE_ORDER_LIST } from '../../constants/routeConstants';
import ConfirmDialog from '../../share-components/ConfirmDialog';
import AlertDialog from '../../share-components/AlertDialog';
import FormTitle from '../../share-components/FormTitle';
import noImage from '../../assets/No_Image_Available.jpg';
import CustomerReceipt from './CustomerReceipt';

const OrderDetails = () => {

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const { orderId } = useParams();
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const [originalOrderCartData, setOriginalOrderCartData] = useState([]);
    const [subtotalAmount, setSubtotalAmount] = useState(0);
    const [orderInfo, setOrderInfo] = useState(null);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showFinishOrderConfirmDialog, setShowFinishOrderConfirmDialog] = useState(false);
    const [isFinishProcess, setIsFinishProcess] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        setRouteNaviData("ORDER >> ORDER DETAILS");
        fetchOrderDetails();
    }, []);

    const fetchOrderDetails = async () => {
        if ((parseInt(orderId) || 0) <= 0) {
            return;
        }
        setLoading(true);
        try {
            // const response = await getAdminAccounts() || [];
            const response = await getOrderDetails(orderId);
            const orderInfo = response?.orderInfo;
            const orderCart = response.orderCartData || [];

            const totalOrderAmount = (orderCart).reduce((sum, order) => sum + (parseInt(order.salePrice) * parseInt(order.orderedQuantity)), 0) || 0;
            setSubtotalAmount(totalOrderAmount);

            setOriginalOrderCartData(orderCart);
            setOrderInfo(orderInfo);
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = async () => {
        try {
            setShowConfirmDialog(false);
            setLoading(true);
            await cancelOrder(orderId);
            setIsFinishProcess(false);
            setShowSuccessDialog(true);
            setLoading(false);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
            setLoading(false);
        }
    }

    const handleFinish = async () => {
        try {
            setShowFinishOrderConfirmDialog(false);
            setLoading(true);
            await finishOrder(orderId);
            setIsFinishProcess(true);
            setShowSuccessDialog(true);
            setLoading(false);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
            setLoading(false);
        }
    }

    const handleSuccessDialogClose = async () => {
        setShowSuccessDialog(false);
        setIsFinishProcess(false);
        await fetchOrderDetails();
    }

    const checkIsRequiredPaymentReceivedBy = (orderStatus) => {
        return parseInt(orderStatus) === ORDER_STATUS_DEFINE.paid.value || parseInt(orderStatus) === ORDER_STATUS_DEFINE.shipped.value || parseInt(orderStatus) === ORDER_STATUS_DEFINE.finished.value;
    }

    const getShowData = (orderCartItem) => {
        return (<div>
            <div style={{
                fontWeight: '600',
                display: 'flex',
            }}>
                <div style={{ flex: "1", paddingRight: "10px" }}>
                    <div><i className='bi bi-award'></i> {orderCartItem?.brandName}</div><hr className='m-0' />
                    <div><i className='bi bi-box'></i> {orderCartItem?.productName}</div><hr className='m-0' />
                    <div><i className='bi bi-tags'></i> {orderCartItem?.categoryName}</div><hr className='m-0' />
                    {(!isNullOrEmptyString(orderCartItem?.size) || !isNullOrEmptyString(orderCartItem.color)) &&
                        <>
                            <div>
                                <i className='bi bi-palette'></i> {!isNullOrEmptyString(orderCartItem.color) && <span>[{orderCartItem.color}]</span>}{!isNullOrEmptyString(orderCartItem?.size) && <span>[{orderCartItem.size}]</span>}

                            </div><hr className='m-0' />
                        </>
                    }
                    <div><i className='bi bi-cash'></i> {orderCartItem?.salePrice}¥ x({orderCartItem?.orderedQuantity})</div><hr className='m-0' />
                </div>
                <div style={{ paddingTop: "5px" }}>
                    <img
                        src={orderCartItem?.productPicture ? `data:image/jpeg;base64,${orderCartItem?.productPicture}` : noImage}
                        alt="picture"
                        className="img-thumbnail"
                        style={{ width: "var(--orderProductPictureWidth)", height: "var(--orderProductPictureHeight)", objectFit: "cover" }}
                    />
                </div>
            </div>
        </div>
        )
    };

    const getOrderCartCount = () => {
        const totalOrderCount = originalOrderCartData?.reduce((sum, item) => sum + item.orderedQuantity, 0);
        return totalOrderCount || 0;
    }

    const orderTotal = (originalOrderCartData).reduce((sum, order) => sum + (parseInt(order.salePrice) * parseInt(order.orderedQuantity)), 0) || 0;

    return (
        <div id='detailsOrderPage' style={{ paddingBottom: '50px' }}>
            <FormTitle title={"Order Details"} isCenter={true} />
            {isFirstLoaded && <Card style={{ padding: '10px', margin: '0 auto', maxWidth: '650px' }}>

                <Card.Body className='pt-2'>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="" style={{ maxWidth: '550px' }}>
                                <div className='mb-3 center-block-column'>
                                    {originalOrderCartData.map((orderCart, index) => (
                                        <div key={index} className='info-card'
                                        // style={{ animationDelay: `${index * 0.6}s` }}
                                        >
                                            {getShowData(orderCart)}
                                        </div>
                                    ))}
                                </div>
                                <div style={{
                                    padding: '5px',
                                    background: 'chartreuse',
                                    borderRadius: '15px',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '1rem',
                                    marginBottom: '15px'
                                }}>
                                    <span>Ordered ({getOrderCartCount()} item{(getOrderCartCount()) > 1 ? "s" : ""})</span>
                                </div>

                                <div className="mb-1">
                                    <label className="custom-label">Customer Name</label>
                                    <div className="w-100 label-box main-description">
                                        {orderInfo?.customerName}
                                    </div>
                                </div>

                                {!isNullOrEmptyString(orderInfo?.customerAddress?.trim()) && <div className="mb-1">
                                    <label className="custom-label">Customer Address</label>
                                    <div className="w-100 label-box">
                                        {orderInfo?.customerAddress}
                                    </div>
                                </div>}

                                <div className="mb-1">
                                    <label className="custom-label">Order Status</label>
                                    <div className="w-100 label-box main-description"
                                        style={{
                                            background: `${orderInfo?.orderStatus === ORDER_STATUS_DEFINE.cancelled.value ? "red" : ""}`
                                        }}
                                    >
                                        {ORDER_STATUS.find(status => status.value === parseInt(orderInfo?.orderStatus))?.text}
                                    </div>
                                </div>

                                <div className="mb-1">
                                    <label className="custom-label">Ordered By</label>
                                    <div className="w-100 label-box main-description">
                                        {orderInfo?.orderedBy}
                                    </div>
                                </div>

                                <div className="mb-1">
                                    <label className="custom-label">Ordered Date</label>
                                    <div className="w-100 label-box">
                                        {formatDateTime(orderInfo?.createdDateTime)}
                                    </div>
                                </div>

                                {orderInfo?.createdById !== orderInfo?.lastUpdatedById && <div className="mb-1">
                                    <label className="custom-label">Last Updated By</label>
                                    <div className="w-100 label-box">
                                        {orderInfo?.lastUpdatedBy}
                                    </div>
                                </div>}

                                {orderInfo?.createdDateTime !== orderInfo?.lastUpdatedDateTime && <div className="mb-1">
                                    <label className="custom-label">Last Updated Date</label>
                                    <div className="w-100 label-box">
                                        {formatDateTime(orderInfo?.lastUpdatedDateTime)}
                                    </div>
                                </div>}

                                <div className="mb-1">
                                    <label className="custom-label">Delivery Type</label>
                                    <div className="w-100 label-box">
                                        {DELI_TYPES.find(type => type.value === parseInt(orderInfo?.deliveryType))?.text}
                                    </div>
                                </div>

                                {((parseInt(orderInfo?.deliveryType) || null) === DELI_TYPE_DEFINE.prepaidDelivery.value ||
                                    (parseInt(orderInfo?.deliveryFee) || 0) > 0) && <div className="mb-1">
                                        <label className="custom-label">DeliveryFee Fees</label>
                                        <div className="w-100 label-box">
                                            {orderInfo?.deliveryFee}¥
                                        </div>
                                    </div>}

                                <div className="mb-1">
                                    <label className="custom-label">Delivered By</label>
                                    <div className="w-100 label-box main-description">
                                        {orderInfo?.deliveredBy || ""}
                                    </div>
                                </div>

                                <div className="mb-1">
                                    <label className="custom-label">Shipping Tracker Link</label>
                                    <div className="w-100 label-box" >
                                        {isValidHttpUrl(orderInfo?.shippingTrackerLink) ? <a
                                            href={`${orderInfo?.shippingTrackerLink}`}
                                            target='_blank'
                                            rel="noopener noreferrer nofollow"
                                            referrerPolicy="no-referrer"
                                        >
                                            {orderInfo?.shippingTrackerLink}
                                        </a> : orderInfo?.shippingTrackerLink}
                                    </div>
                                </div>

                                <div className="mb-1">
                                    <label className="custom-label">Subtotal Price</label>
                                    <div className="w-100 label-box">
                                        {subtotalAmount}¥
                                    </div>
                                </div>

                                {orderInfo?.serviceCharge > 0 && <div className="mb-1">
                                    <label className="custom-label">Service Charge</label>
                                    <div className="w-100 label-box">
                                        {orderInfo?.serviceCharge}¥
                                    </div>
                                </div>}

                                {orderInfo?.tipMoney > 0 && <div className="mb-1">
                                    <label className="custom-label">Tip Money</label>
                                    <div className="w-100 label-box">
                                        {orderInfo?.tipMoney}¥
                                    </div>
                                </div>}

                                <div className="mt-3 form-check form-switch form-check-reverse text-start mb-2" >
                                    <label className="form-check-label custom-label">
                                        PR Gift Include?
                                        <input type="checkbox" checked={orderInfo?.prGiftFlag === true} className="form-check-input ms-2" disabled />
                                    </label>
                                </div>

                                {orderInfo?.prGiftFlag === true && <div className="mb-1">
                                    <label className="custom-label">PR Gift Price</label>
                                    <div className="w-100 label-box">
                                        {orderInfo?.prGiftAmount}¥
                                    </div>
                                </div>}

                                <div className="mb-1">
                                    <label className="custom-label">Payment Received Amount</label>
                                    <div className="w-100 label-box main-description">
                                        {orderInfo?.paymentReceivedAmount}¥
                                    </div>
                                </div>

                                {checkIsRequiredPaymentReceivedBy(orderInfo?.orderStatus) &&
                                    <>
                                        <div className="mb-1">
                                            <label className="custom-label">Payment Received By</label>
                                            <div className="w-100 label-box main-description">
                                                {orderInfo?.paymentReceivedBy}
                                            </div>
                                        </div>

                                        <div className="mb-1">
                                            <label className="custom-label">Received Bank Name</label>
                                            <div className="w-100 label-box">
                                                {orderInfo?.receivedBankName}
                                            </div>
                                        </div>
                                    </>
                                }

                                <div className="mb-1">
                                    <label className="custom-label">Comment</label>
                                    <div className="w-100 label-box input-area">
                                        {orderInfo?.comment}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
                <ConfirmDialog
                    dialogId='cancelOrderConfirmDialog'
                    showDialog={showConfirmDialog}
                    // title='Logout Dialog'
                    body='Are you sure to cancel the order?'
                    onConfirm={handleCancel}
                    onCancel={() => { setShowConfirmDialog(false); }}
                />
                <ConfirmDialog
                    dialogId='finishOrderConfirmDialog'
                    showDialog={showFinishOrderConfirmDialog}
                    // title='Logout Dialog'
                    body='Are you sure this order is finished?'
                    onConfirm={handleFinish}
                    onCancel={() => { setShowFinishOrderConfirmDialog(false); }}
                />
                <AlertDialog
                    dialogId={'successDialog'}
                    showDialog={showSuccessDialog}
                    body={`${isFinishProcess ? 'Order is successfully finished.' : 'Order is successfully cancelled.'}`}
                    onConfirm={handleSuccessDialogClose}
                />
                <div className='floating-bottom-btn-group'>
                    <div className='floating-bottom-btn-grid'>
                        {/* <Button
                            className="appBtn w-100"
                            type="button"
                            variant="secondary"
                            onClick={() => navigate(ROUTE_ORDER_LIST)}
                        >
                            Go to Order List
                        </Button> */}
                        {(orderInfo?.orderStatus !== ORDER_STATUS_DEFINE.cancelled.value) && <CustomerReceipt
                            customerName={orderInfo?.customerName}
                            orderCartData={(originalOrderCartData)}
                            orderTotal={orderTotal}
                            orderId={orderId}
                            date={orderInfo?.createdDateTime}
                            deliType={orderInfo?.deliveryType}
                            discount={orderInfo?.prGiftAmount}
                            serviceCharge={orderInfo?.serviceCharge}
                            tipMoney={orderInfo?.tipMoney}
                            deliFee={orderInfo?.deliveryFee}
                        />}


                        <Button
                            className="appBtn w-100"
                            type="button"
                            variant="secondary"
                            onClick={() => navigate(ROUTE_ORDER_LIST)}
                        >
                            Go to Order List
                        </Button>

                        <Button
                            className="appBtn w-100"
                            type="button"
                            variant="warning"
                            onClick={() => navigate(ROUTE_ORDER_CREATE)}
                        >
                            Add New Order
                        </Button>

                        {orderInfo?.orderedById === currentUser?.userId &&
                            orderInfo?.orderStatus !== ORDER_STATUS_DEFINE.finished.value &&
                            orderInfo?.orderStatus !== ORDER_STATUS_DEFINE.cancelled.value && <Button
                                className="appBtn w-100"
                                type="button"
                                variant="secondary"
                                onClick={() => navigate(`${ROUTE_ORDER_EDIT}/${orderId}`)}
                            >
                                Edit
                            </Button>}

                        {orderInfo?.orderedById !== currentUser?.userId && orderInfo?.deliveredById === currentUser?.userId &&
                            orderInfo?.orderStatus === ORDER_STATUS_DEFINE.shipped.value && <Button
                                className="appBtn w-100"
                                type="button"
                                variant="secondary"
                                onClick={() => navigate(`${ROUTE_ORDER_DELI_EDIT}/${orderId}`)}
                            >
                                Edit Delivery Info
                            </Button>}

                        {(orderInfo?.deliveredById === currentUser?.userId && orderInfo?.orderStatus === ORDER_STATUS_DEFINE.shipped.value) && <Button
                            className="appBtn w-100"
                            type="button"
                            variant="success"
                            onClick={() => setShowFinishOrderConfirmDialog(true)}
                        >
                            Finish Order
                        </Button>}

                        {(orderInfo?.orderedById === currentUser?.userId ||
                            orderInfo?.deliveredById === currentUser?.userId) &&
                            orderInfo?.orderStatus !== ORDER_STATUS_DEFINE.cancelled.value && <Button
                                className="appBtn w-100"
                                type="button"
                                variant="danger"
                                onClick={() => setShowConfirmDialog(true)}
                            >
                                Cancel Order
                            </Button>}
                    </div>
                </div>
            </Card>}
        </div>
    );
};

export default OrderDetails;